import { Tab, Tabs, type SxProps, type Theme } from "~/common/mui";
import { ControlField } from "./ControlField";
import type { TabSelectControlViewModel } from "./controlViewModel";

export interface TabSelectControlProps extends Omit<TabSelectControlViewModel, "type" | "controlIndex"> {
  onChange: (value: string) => void;
  className?: string;
  sx?: SxProps<Theme>;
}

export const TabSelectControl = ({
  label,
  hideLabel,
  info,
  helperText,
  error,
  errorText,
  disabled = false,
  value,
  options,
  onChange,
  className,
  sx,
}: TabSelectControlProps) => (
  <ControlField
    label={label}
    hideLabel={hideLabel}
    info={info}
    helperText={helperText}
    error={Boolean(error)}
    errorText={errorText}
    className={className}
    sx={sx}
  >
    <Tabs
      value={value ?? false}
      onChange={(_, selectedValue) => onChange(selectedValue as string)}
      variant="fullWidth"
      aria-label={label}
      allowScrollButtonsMobile
      sx={{ width: "100%" }}
    >
      {options.map((option) => (
        <Tab key={option.value} value={option.value} label={option.label} disabled={disabled || option.disabled} />
      ))}
    </Tabs>
  </ControlField>
);
